import type { AjaxResponse, WrappedFetchParams } from '@dustess/iquery';
import { createAxios, interceptorsRequest, interceptorsResponse, interceptorsToast } from '@dustess/iquery';
import { Toast } from '@cfx/base-mobile';
import { getCUser } from '@cfx/icorki-jwx';
import { getUser } from '@dustess/itimo-core';
import customerErrorCode from './customerErrorCode';
import { getEnv } from '@/utils/env';
import { handleAuth } from '@/utils/auth';

const Message = { error: Toast.fail };

// 企微可以替换成企微端的URL
const { VUE_APP_M_C_BASE_URL } = getEnv();

const { ajax, abort, request, webGateway } = createAxios({ baseURL: VUE_APP_M_C_BASE_URL });

if (process.env.NODE_ENV === 'development') {
  interceptorsToast('console', { error: console.error.bind(console, 'axios.interceptors.log') });
}

interceptorsRequest('Authorization', (config) => {
  // 先获取B端session，再获取C端session
  const sessionId = getUser('pc')?.sid || getUser('qw')?.sid || getCUser()?.sessionId || '';
  config.headers.Authorization = sessionId;
  // 添加灰度标识
  const account = window.sessionStorage.getItem('reportAccount');
  if (account) {
    config.headers.Account = account;
    config.headers['x-auth-accountid'] = account;
  }
}, 99);

interceptorsResponse('NoAccess', (response) => {
  const { status, data = {} } = response;
  const { code } = data;
  if (code === 4001 || status === 401) {
    // 401 重新登
    localStorage.removeItem('c_user');
    localStorage.removeItem('user');
    localStorage.removeItem('qw-user');
    localStorage.removeItem('platform-user');
    handleAuth();
  }

  // 处理自定义错误码
  if (customerErrorCode[code]) Message.error(customerErrorCode[code]);
});

const check = <V> (value: V, name: string): void => {
  if (value === null || value === undefined) {
    const msg = `[ERROR PARAMS]: ${name} can't be null or undefined`;
    // 非生产环境，直接抛出错误
    if (process.env.NODE_ENV === 'development') throw new Error(msg);
  }
};

function factory(method: WrappedFetchParams['method']) {
  return function<T = any, R = any> (url: string, params: R, extraParams?: Partial<WrappedFetchParams<R>>) {
    const p: any = {};
    method === 'GET' ? p.query = params : p.data = params;
    return request<AjaxResponse<T>>({
      url,
      method,
      ...p,
      ...extraParams
    });
  };
}

const [post, get] = [factory('POST'), factory('GET')];

const wrappedFetch = {
  ajax,
  check,
  abort,
  request,
  webGateway
};

export type { AjaxPromise, ExtraFetchParams } from '@dustess/iquery';

export default wrappedFetch;

export { abort, request, webGateway };

export { post, get, check };
